module.exports = __webpack_public_path__ + "img/help.22cf7f1d.svg";